/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindProductStandardCertificatesQueryResponse,
  FindProductStandardCertificatesQueryParams,
} from "../types/FindProductStandardCertificates.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findProductStandardCertificatesQueryKey = (
  params: FindProductStandardCertificatesQueryParams
) =>
  [
    { url: "/v1/certificate/find-product-standard-certificates" },
    ...(params ? [params] : []),
  ] as const

export type FindProductStandardCertificatesQueryKey = ReturnType<
  typeof findProductStandardCertificatesQueryKey
>

/**
 * @summary Find product standard certificates
 * {@link /v1/certificate/find-product-standard-certificates}
 */
export async function findProductStandardCertificates(
  params: FindProductStandardCertificatesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductStandardCertificatesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/certificate/find-product-standard-certificates`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductStandardCertificatesQueryOptions(
  params: FindProductStandardCertificatesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductStandardCertificatesQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductStandardCertificatesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductStandardCertificatesQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductStandardCertificates(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find product standard certificates
 * {@link /v1/certificate/find-product-standard-certificates}
 */
export function useFindProductStandardCertificates<
  TData = ResponseConfig<FindProductStandardCertificatesQueryResponse>,
  TQueryData = ResponseConfig<FindProductStandardCertificatesQueryResponse>,
  TQueryKey extends QueryKey = FindProductStandardCertificatesQueryKey,
>(
  params: FindProductStandardCertificatesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductStandardCertificatesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findProductStandardCertificatesQueryKey(params)

  const query = useQuery(
    {
      ...findProductStandardCertificatesQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
